import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {EventType, generateTargetTypeText, TargetEvent, TargetType} from '../../../../../models/PartEvent';
import {v4} from 'uuid';

interface OwnProps {
    onSubmit: (partEvent: Omit<TargetEvent, 'anchor'>) => void;
    onCancel: () => void;
}

export const TargetStepComponent: FunctionComponent<OwnProps> = ({onSubmit, onCancel}) => {
    const [targetType, setTargetType] = useState<TargetType>(TargetType.StrokeRate);
    const [value, setValue] = useState<number | null>(20);

    function getTargetValueForm(): JSX.Element {
        switch (targetType) {
            case TargetType.StrokeRate:
                return (
                    <div className="form-group">
                        <label htmlFor="distance_meters">Stroke rate (spm)</label>
                        <input
                            id="distance_meters"
                            type="number"
                            name="distance_meters"
                            className="form-control"
                            value={value || ''}
                            onChange={(e) => {
                                setValue(e.target.value === '' ? null : parseInt(e.target.value, 10));
                            }}
                        />
                    </div>
                );
        }
    }

    return (
        <>
            <div className="modal-header">
                <h2>Choose target</h2>
            </div>
            <div className="modal-body">
                <div className="add-event-wizard">
                    <form>
                        <div className="form-group">
                            <label htmlFor="target-type">Target</label>
                            <select
                                className="form-control-select"
                                id="target-type"
                                name="target-type"
                                onChange={(e) => setTargetType(e.target.value as TargetType)}
                                value={targetType}
                            >
                                {Object.values(TargetType).map((tt) => (
                                    <option key={tt} value={tt}>
                                        {generateTargetTypeText(tt, value)}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {getTargetValueForm()}
                    </form>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    className="btn btn-secondary pull-right"
                    disabled={value === null}
                    onClick={() => {
                        if (value === null) {
                            return null;
                        }
                        onSubmit({
                            __uuid: v4(),
                            type: EventType.Target,
                            key: targetType,
                            value: value,
                        });
                    }}
                >
                    Next
                </button>
                <button className="btn btn-secondary pull-right" onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </>
    );
};
